import React from "react";
import {
    Button,
  Container,
  Content,
  HomeData,
  HomeDescription,
  HomeImg,
  HomeScroll,
  HomeScrollBtn,
  HomeScrollName,
  HomeSubtitle,
  HomeTitle,
  Section,
  Social,
  SocialIcon,
} from "./HomeSectionStyles";
import {
  UilLinkedinAlt,
  UilGithubAlt,
  UilDribbble,
  UilMessage,
  UilMouseAlt,
  UilArrowDown,
} from "@iconscout/react-unicons";

function HomeSection() {
  return (
    <Section className="home-section">
      <Container>
        <Content>
          <Social>
            <SocialIcon
              to={{ pathname: "https://www.linkedin.com/in/oji-ubasi-b67b581a8?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BdX7LCQd4QNKbJeKbhdcPQg%3D%3D" }}
              target="_blank"
            >
              <UilLinkedinAlt />
            </SocialIcon>
            <SocialIcon
              to={{ pathname: "https://www.dribbble.com/" }}
              target="_blank"
            >
              <UilDribbble />
            </SocialIcon>
            <SocialIcon
              to={{ pathname: "https://github.com/ojiubasi-motif" }}
              target="_blank"
            >
              <UilGithubAlt />
            </SocialIcon>
          </Social>
          <HomeImg>
            <svg className="home__blob" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                   <mask id="mask0" mask-type="alpha">
                   <path d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 165.547 
                    130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 129.362C2.45775 
                    97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 -0.149132 97.9666 
                    0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z"/>
                   </mask>
                    <g mask="url(#mask0)">
                    <path d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 165.547 
                    130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 129.362C2.45775 
                    97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 -0.149132 97.9666 
                    0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z"/>
                        <image className="home_blob-img" x="12" y="-30" href="/img/homeImg.png" />
                    </g>
            </svg>
          </HomeImg>
          <HomeData>
              <HomeTitle>Hi, I am Oji,</HomeTitle>
              <HomeSubtitle>Fullstack Web Developer</HomeSubtitle>
              <HomeDescription>
                  High level experience in web design and 
                  development using latest technologies, producing quality work.
              </HomeDescription>
              <Button to="contact-section"
                  activeClass="active"
                  spy={true}
                  smooth={true}
                  offset={30}
                  duration={300}
                  hashSpy={true}
              >
                  Contact Me <UilMessage size="1.25rem" className="btn__icon"/>
              </Button>
          </HomeData>
        </Content>

        <HomeScroll>
            <HomeScrollBtn
              to="about-section"
              activeClass="active"
              spy={true}
              smooth={true}
              offset={30}
              duration={300}
              hashSpy={true}
            >
                <UilMouseAlt className="home__scroll-mouse"/>
                <HomeScrollName>Scroll down</HomeScrollName>
                <UilArrowDown className="home__scroll-arrow"/>
            </HomeScrollBtn>
        </HomeScroll>
      </Container>
    </Section>
  );
}

export default HomeSection;
